module.exports = __webpack_public_path__ + "static/media/gnj.bfaedf8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gnj/gnj.png
// module id = 34
// module chunks = 0